import styled from 'styled-components';

export const SelectItemWrapper = styled.span`
  &:hover {
    background: #cecece;
  }
  background: #ffffff;
`;
